import { NgStyle } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemesWrapperComponent } from "../themes-wrapper/themes-wrapper.component";
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-carte-prestation',
  imports: [NgStyle, RouterLink, ThemesWrapperComponent],
  templateUrl: './carte-prestation.component.html',
  styleUrl: './carte-prestation.component.scss'
})
export class CartePrestationComponent {
  @Input() prestation: any;
  
  private apiService = inject(ApiService);

  getImageUrl(url: string): string {
    return this.apiService.getImageUrl(url);
  }
}
